import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { Employee } from 'src/app/employee/models/Employee';
import { EmployeeService } from 'src/app/employee/services/employee.service';
import { PropertyService } from 'src/app/property/services/property.service';
import { FlatpickrHelper } from 'src/app/shared/common/FlatpickrHelper';
import { FormHelper } from 'src/app/shared/common/FormHelper';
import { FlatpickrLocaleService } from 'src/app/shared/services/flatpickr-locale.service';

@Component({
    selector: 'multi-assign-unassign-property.component',
    templateUrl: './multi-assign-unassign-property.component.html',
    styleUrls: ['./multi-assign-unassign-property.component.css']
})
export class MultiAssignUnassignPropertyComponent implements OnInit {
    public locale$ = this._flatpickrLocale.currentFlatpickrLocale$;
    public employees$: Observable<Array<Employee>>;
    public propertyIDs: number[];
    public form: UntypedFormGroup;
    public submitted = false;
    public action: 'assign' | 'unassign' = 'assign';
    public employeeID: number;

    public constructor(
        public activeModal: NgbActiveModal,
        private _employeeService: EmployeeService,
        public fpHelper: FlatpickrHelper,
        private _fb: UntypedFormBuilder,
        private _flatpickrLocale: FlatpickrLocaleService,
        private _formHelper: FormHelper,
        private _modalService: NgbModal,
        private _propertyService: PropertyService
    ) { }

    public get f(): { [formControlName: string]: AbstractControl; } {
        return this.form.controls;
    }

    public ngOnInit(): void {
        this.form = this._fb.group({
            employee_ID: [null, Validators.required],
            handover_date: ['', Validators.required],
        });

        this.form.patchValue({
            employee_ID: this.employeeID ?? null,
            handover_date: new Date().toISOString().substring(0, 10)
        });

        this.employees$ = this._employeeService.getAllEmployees();
    }

    public onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this._propertyService.multiAssignUnAssignPropertiesToEmployee(this.form.value, this.propertyIDs, this.action)
            .then(() => this.activeModal.close('close'));
    }
}
